import * as React from 'react'

import { cn } from '@/lib/utils'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error = false, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          cn(
            'flex min-h-[80px] w-full rounded-md border bg-neutral-50 px-3 py-2',
            'text-sm shadow-sm placeholder:text-gray-400',
            'focus-visible:outline-none focus-visible:ring-1',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'resize-y'
          ),
          error
            ? 'border-red-500 focus-visible:ring-red-500'
            : 'border-neutral-300 focus-visible:ring-neutral-500',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }
